/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import './guides.css';

/*
#tailwind
*/

const Guides = ({ rows, columns }) => (
  <table className="guides">
    <tbody>
      {Array(rows)
        .fill(0)
        .map((_, r) => (
          <tr key={r}>
            {Array(columns)
              .fill(0)
              .map((__, c) => (
                <td key={c} className="guides__cell" />
              ))}
          </tr>
        ))}
    </tbody>
  </table>
);

Guides.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
};

Guides.defaultProps = {
  rows: 3,
  columns: 3,
};

export default Guides;
